var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2447 2c1.0889 0 2.0696.4634 2.7555 1.2038C9.6862 2.4634 10.6668 2 11.7557 2c2.0913 0 3.4244 2.1637 2.5887 4H19c1.6569 0 3 1.3431 3 3v8c0 1.6569-1.3431 3-3 3H5c-1.6568 0-3-1.3431-3-3V9c0-1.2254.7346-2.2791 1.7875-2.7449C2.6974 4.3707 4.0556 2 6.2447 2zm-.2783 4h2.0338v-.2445C8.0002 4.786 7.2142 4 6.2447 4c-.6506 0-1.0525.7097-.7177 1.2676L5.9664 6zm4.0338 0h2.0338l.4394-.7324C12.8082 4.7097 12.4063 4 11.7557 4c-.9695 0-1.7555.786-1.7555 1.7555V6zM10 8v2h10V9c0-.5523-.4477-1-1-1h-9zM8 8H5c-.5523 0-1 .4477-1 1v1h4V8zm-4 5h4v5H5c-.5523 0-1-.4477-1-1v-4zm16 0H10v5h9c.5523 0 1-.4477 1-1v-4z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7689af46da7d1664154f2237ad79939e.svg";
export { ForwardRef as ReactComponent };